module.exports = __webpack_public_path__ + "img/CipherTrace.aa724b50.png";